export const APP_NAME = "Shop Anywhere";

// URLs
export const CLIENT_URL = window.location.origin;
export const SERVER_URL = "http://localhost:3200";
